import React, { useState, useEffect } from 'react';
import styles from './TemplateHero4.module.css';

const TemplateHero4 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Same as 1, 2, & 3)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000); // Slightly slower for the Ken Burns effect

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        >
          <div className={styles.sideOverlay}></div>
        </div>
      ))}

      {/* Decorative vertical text */}
      <div className={styles.verticalTag}>
        <span>EXPLORE THE EXTRAORDINARY</span>
      </div>

      {/* Content Area (Right Aligned) */}
      <div className={styles.mainWrapper}>
        <div className={styles.contentBox} key={`box-${currentSlide}`}>
          <h2 className={styles.overline}>Premium Experience</h2>
          <h1 className={styles.title}>{slides[currentSlide].title}</h1>
          <p className={styles.subtitle}>{slides[currentSlide].subtitle}</p>
          
          <div className={styles.buttonGroup}>
            <button className={styles.primaryBtn}>
              Start Journey
            </button>
            <button className={styles.outlineBtn}>
              Our Story
            </button>
          </div>
        </div>
      </div>

      {/* Numbered Navigation (Right Side) */}
      {slides.length > 1 && (
        <div className={styles.numNav}>
          {slides.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.navItem} ${index === currentSlide ? styles.activeNav : ''}`}
            >
              <span className={styles.navNum}>0{index + 1}</span>
              <div className={styles.navLine}></div>
            </div>
          ))}
        </div>
      )}

      {/* Scroll Down Hint */}
      <div className={styles.scrollHint}>
        <div className={styles.mouse}>
          <div className={styles.wheel}></div>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero4;